import FormattedMessage from 'I18n/components/FormattedMessage';
import { INVALID_NAME_WITH_QUOTES } from '../PropertyValidationErrorCodes';
import { INVALID, VALID } from '../PropertyValidationStatus';
import { jsx as _jsx } from "react/jsx-runtime";
function containsQuotes(value) {
  return value && `${value}`.includes('"');
}
function createValidationDetails(validationRequest) {
  const doesContainQuotes = containsQuotes(validationRequest.value);
  if (validationRequest.value && doesContainQuotes) {
    return {
      errors: [{
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.propertyValidationErrorMessages.invalidNameWithQuotes"
        }),
        code: INVALID_NAME_WITH_QUOTES
      }],
      validationRequest,
      validationStatus: INVALID
    };
  }
  return {
    errors: [],
    validationRequest,
    validationStatus: VALID
  };
}

/**
 * Contact names that contained double quotes were causing email sending to fail
 * and was fixed in https://git.hubteam.com/HubSpot/CRM/pull/10880.
 * This validator ensures strings have the correct format to be a contact name which
 * eventually might not even be required as part of frontend validation.
 **/

export const namePropertyValidator = validationRequest => Promise.resolve(createValidationDetails(validationRequest));